import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { UpgraderNewService } from '../../services/upgrader-new.service';
import { SessionService } from '@core/services/session.service';
import { UpgraderItemsInfoComponent } from '../upgrader-items-info/upgrader-items-info.component';
import { TargetFrameSvgComponent } from '../../svg/target-frame-svg.component';
import { TargetGlowSvgComponent } from '../../svg/target-glow-svg.component';
import {SvgIconComponent} from "angular-svg-icon";

@Component({
  selector: 'app-upgrader-target-panel',
  standalone: true,
  imports: [CommonModule, DecimalPipe, UpgraderItemsInfoComponent, TargetFrameSvgComponent, TargetGlowSvgComponent, SvgIconComponent],
  templateUrl: './upgrader-target-panel.component.html',
  styleUrl: './upgrader-target-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgraderTargetPanelComponent {
  protected readonly upgraderService = inject(UpgraderNewService);
  protected readonly sessionService = inject(SessionService);

  // Sorted skins by price (most expensive first)
  protected readonly sortedSkins = computed(() =>
    [...this.upgraderService.selectedTargetSkins()].sort((a, b) => b.price - a.price)
  );

  // Most expensive skin (main display)
  protected readonly primarySkin = computed(() => this.sortedSkins()[0] ?? null);

  // Outputs
  readonly upgrade = output<void>();
  readonly interacted = output<void>();

  protected onUpgrade(): void {
    this.upgrade.emit();
  }

  protected onClearTargets(): void {
    this.upgraderService.clearTargetSkins();
    this.interacted.emit();
  }

  protected onToggleFastMode(): void {
    this.upgraderService.toggleFastMode();
    this.interacted.emit();
  }
}
